module.exports = __webpack_public_path__ + "img/vignettes-asso_0002_universite-automne-femmes-tunisiennes.d6a01740.jpg";